import Stack from '@mui/material/Stack';
import { config } from 'config';
import { useAuth } from 'modules/auth/auth.context';
import { SectionTitle } from 'modules/shared/components';
import HomeOverview from 'modules/dashboards/pages/HomeOverview';
import AnalystHome from './analyst/AnalystHome';
import EmployeeHome from './employee/EmployeeHome';

const USER_ROLES = config.USER_ROLES;

/** What follows "Your overview" for each role; `null` means the overview alone. */
const ROLE_HOME_MAP: Record<string, React.ComponentType | null> = {
  [USER_ROLES.ANALYST]: AnalystHome,
  [USER_ROLES.EMPLOYEE]: EmployeeHome,
  // Admin, HR and Accounts get the module cards only. The old admin/HR dashboard repeated what
  // the HR, Recruitment, Billing and Payroll dashboards show, so Home showed most numbers twice.
  [USER_ROLES.ACCOUNTS]: null,
  [USER_ROLES.HR]: null,
  [USER_ROLES.ADMIN]: null,
};

export default function HomeByRole() {
  const { role, user } = useAuth();

  // Roles added on Roles & Menu Access (site engineer, …) start from the employee home: their
  // own work, with the rest of the menu in the sidebar.
  const HomeComponent = Object.hasOwn(ROLE_HOME_MAP, role ?? '') ? ROLE_HOME_MAP[role] : EmployeeHome;
  const name = (user as Record<string, any> | null)?.name;

  return (
    <Stack gap={4}>
      <SectionTitle title={name ? `WELCOME, ${String(name).toUpperCase()}` : 'HOME'} />
      <HomeOverview />
      {HomeComponent && <HomeComponent />}
    </Stack>
  );
}
